import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import makeStyles from '@mui/styles/makeStyles';
import Styles from './styles';

const useStyles = makeStyles(Styles);

function BankIcon({ classes }) {
  const styles = useStyles();
  const iconClasses = cn(styles.BankIcon, classes);

  return (
    <svg className={iconClasses} xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M2 20h20v2H2v-2zm2-8h2v7H4v-7zm5 0h2v7H9v-7zm4 0h2v7h-2v-7zm5 0h2v7h-2v-7zM2 7l10-5 10 5v4H2V7zm2 1.236V9h16v-.764l-8-4-8 4zM12 8a1 1 0 1 1 0-2 1 1 0 0 1 0 2z" />
    </svg>
  );
}

BankIcon.propTypes = {
  classes: PropTypes.string,
};

BankIcon.defaultProps = {
  classes: '',
};

export default BankIcon;
